<template>
  <div v-if="!hideBanner">
    <UpsellPaymentBanner
      v-if="shouldShowUpsellBanner"
      :show-close-button="false"
      data-qa="pos-upsell-banner"
      source="pos-banner"
    />

    <VcBanner
      v-else
      class="pos-banner"
      data-qa="pos-banner"
      :title="$t('point_of_sale.banner.title')"
      :subtitle="$t('point_of_sale.banner.subtitle')"
      :button-label="$t('point_of_sale.banner.button')"
      :link-label="$t('point_of_sale.banner.link')"
      :image="posBannerImage"
      close-button
      @onAction="$emit('onAction')"
      @closeBanner="hideBanner = true"
    />
  </div>
</template>

<script>
import UpsellPaymentBanner from '@/modules/common/components/UpsellPaymentBanner';
import posBannerImage from '@/assets/images/payments/pos-banner.svg';

export default {
  name: 'PosBanner',
  components: {
    UpsellPaymentBanner,
  },
  data() {
    return {
      hideBanner: false,
      posBannerImage,
    };
  },
  computed: {
    shouldShowUpsellBanner() {
      return !this.$hasFeature('online_payment');
    },
  },
};
</script>

<style lang="scss" scoped>
.pos-banner {
  margin-block-end: var(--size-value6);
}
</style>
